import scrollToDivById from "@/utils/functions/scrollToDivById";
import Image from "next/image";
import React from "react";

const Rating = ({ rating, reviews }) => {
  return (
    <div className="flex items-center gap-1">
      <Image
        src="/icons/star.svg"
        alt="start"
        width={14}
        height={14}
        className="object-contain"
      />
      <span className="text-themeBlack text-sm font-semibold leading-normal">
        {rating}
      </span>
      <span
        className="text-[#9CA5B0] text-size-11 font-medium leading-normal underline cursor-pointer"
        onClick={() => scrollToDivById("reviews")}
      >
        {reviews} yorum
      </span>
    </div>
  );
};

export default Rating;
